import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  breakpoints,
  palette,
  fontSizes,
  fontWeights,
  siteMaxWidth,
}: Theme) => ({
  root: {
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
    height: 'calc(100vh - 5rem)',
    maxHeight: 'fit-content',
    overflowY: 'hidden',
    lineHeight: 0.6,
    '& .MuiTabs-root': {
      position: 'absolute',
      bottom: '2rem',
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 3,
      minHeight: 'unset',
      padding: 2,
      borderRadius: '2rem',
      background: palette.common.white,
      boxShadow: '3px 4px 13px 0 rgba(5, 41, 103, 0.1)',
    },
    '& .MuiTabs-scroller': {
      height: 'min-content',
    },
    '& .MuiTab-fullWidth': {
      minHeight: 'unset',
      padding: '0.5rem 1.5rem',
      borderRadius: '2.5rem',
      color: palette.text.primary,
      fontSize: fontSizes.sm,
      fontWeight: fontWeights.regular,
      lineHeight: 1,
      textTransform: 'none',
      opacity: 1,
      [breakpoints.up('md')]: {
        width: '11.5rem',
      },
      '&.Mui-selected': {
        background: palette.primary.dark,
        color: palette.common.white,
      },
    },
    '& .MuiTabs-indicator': {
      display: 'none',
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75rem',
    width: '100%',
    borderRadius: '0.375rem',
    [breakpoints.up('md')]: {
      width: 'auto',
      height: '100%',
    },
  },
  image: {
    display: 'block',
    width: '100%',
    maxWidth: siteMaxWidth,
    height: 'auto',
    margin: '0 auto',
  },
  panelInner: {
    display: 'flex',
  },
  list: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
  },
  draggableCircle: {
    width: '12.5rem',
    height: '12.5rem',
    backgroundColor: 'transparent',
    border: `0.125rem solid ${palette.common.white}`,
    borderRadius: '50%',
    position: 'absolute',
    top: '20%',
    left: '-5%',
    transform: 'translate(-50%, -50%)',
    zIndex: 10,
    cursor: 'grab',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: fontWeights.regular,
    boxShadow: '0 0.25rem 0.375rem rgba(0, 0, 0, 0.3)',
    [breakpoints.up('sm')]: {
      width: '12.5rem',
      height: '12.5rem',
      left: '17%',
      transform: 'translate(-50%, -50%)',
    },
    [breakpoints.up('lg')]: {
      width: '18.75rem',
      height: '18.75rem',
      transform: 'translate(-50%, -60%)',
      top: '15%',
      left: '30%',
    },
  },
  wrapper:{
    position: 'relative',
    display: 'inline-block',
    width: '100%',
  },
}));
